// extracted by mini-css-extract-plugin
export default {"overridesCard":"Card-module--overrides--Card--UJjdk"};